import { useState } from 'react';
import { usersApi } from '../api';
import { useAuth } from '../hooks/useAuth';

interface Props {
  user?: any;
  onClose: () => void;
  onSave: () => void;
}

export default function UserModal({ user, onClose, onSave }: Props) {
  const { user: currentUser } = useAuth();
  const isAdmin = currentUser?.role === 'ADMIN';
  const [form, setForm] = useState({
    email: user?.email || '',
    password: '',
    firstName: user?.firstName || '',
    lastName: user?.lastName || '',
    role: user?.role || 'MANAGER',
    phone: user?.phone || '',
    isActive: user?.isActive ?? true,
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (user) {
        const data: any = {
          firstName: form.firstName,
          lastName: form.lastName,
          role: form.role,
          phone: form.phone || null,
          isActive: form.isActive,
        };
        await usersApi.update(user.id, data);

        if (isAdmin && form.password) {
          if (form.password.length < 6) {
            alert('Пароль должен содержать минимум 6 символов');
            setLoading(false);
            return;
          }
          await usersApi.setPassword(user.id, form.password);
        }
      } else {
        if (!form.password) {
          alert('Введите пароль для нового пользователя');
          setLoading(false);
          return;
        }
        await usersApi.create({
          email: form.email,
          password: form.password,
          firstName: form.firstName,
          lastName: form.lastName,
          role: form.role,
          phone: form.phone || null,
        });
      }
      onSave();
    } catch (e: any) {
      alert(e.response?.data?.error || 'Ошибка сохранения');
    } finally {
      setLoading(false);
    }
  };

  const roleLabels: Record<string, string> = {
    ADMIN: 'Администратор',
    MANAGER: 'Менеджер',
    VIEWER: 'Наблюдатель',
  };

  return (
    <div className="modal-overlay">
      <div className="modal" onClick={e => e.stopPropagation()} onDoubleClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3 style={{ fontSize: 16, fontWeight: 600 }}>{user ? 'Редактировать пользователя' : 'Новый пользователь'}</h3>
          <button onClick={onClose} style={{ background: 'none', fontSize: 20, cursor: 'pointer' }}>×</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            {!user && (
              <div className="form-group">
                <label className="form-label">Email *</label>
                <input className="form-input" type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required />
              </div>
            )}
            {!user && (
              <div className="form-group">
                <label className="form-label">Пароль *</label>
                <input className="form-input" type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required minLength={6} />
              </div>
            )}
            {user && isAdmin && (
              <div className="form-group">
                <label className="form-label">Новый пароль</label>
                <input className="form-input" type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} minLength={6} placeholder="Оставьте пустым, чтобы не менять" />
              </div>
            )}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <div className="form-group">
                <label className="form-label">Имя *</label>
                <input className="form-input" value={form.firstName} onChange={e => setForm({ ...form, firstName: e.target.value })} required />
              </div>
              <div className="form-group">
                <label className="form-label">Фамилия *</label>
                <input className="form-input" value={form.lastName} onChange={e => setForm({ ...form, lastName: e.target.value })} required />
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <div className="form-group">
                <label className="form-label">Роль</label>
                <select className="form-select" value={form.role} onChange={e => setForm({ ...form, role: e.target.value })}>
                  <option value="VIEWER">{roleLabels.VIEWER}</option>
                  <option value="MANAGER">{roleLabels.MANAGER}</option>
                  <option value="ADMIN">{roleLabels.ADMIN}</option>
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Телефон</label>
                <input className="form-input" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} />
              </div>
            </div>
            {user && (
              <div className="form-group">
                <label className="form-label">Статус</label>
                <select className="form-select" value={form.isActive ? 'true' : 'false'} onChange={e => setForm({ ...form, isActive: e.target.value === 'true' })}>
                  <option value="true">Активен</option>
                  <option value="false">Заблокирован</option>
                </select>
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>Отмена</button>
            <button type="submit" className="btn btn-primary" disabled={loading}>{loading ? 'Сохранение...' : 'Сохранить'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
